import img from '../assets/images/shutterstock_699442570-min.jpg'
import { useState } from 'react';
import constants from '../constants/constants';

export default function Reports() {
    const [popup, setPopup] = useState(false)
    const [formData, setFormData] = useState({
        Name: "",
        "Email Address": "",
        "Client Type": "",
        "Interested in:": [],
    });
    const [formErrors, setFormErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        // Clear error when user starts typing
        if (formErrors[name]) {
            setFormErrors(prev => ({
                ...prev,
                [name]: ""
            }));
        }
    };

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            "Interested in:": checked
                ? [...prev["Interested in:"], value]
                : prev["Interested in:"].filter((interest) => interest !== value),
        }));
        // Clear error when user selects an interest
        if (formErrors["Interested in:"]) {
            setFormErrors(prev => ({
                ...prev,
                "Interested in:": ""
            }));
        }
    };

    // Email validation function
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    // Form validation function
    const validateForm = () => {
        const errors = {};
        
        // Check required fields
        if (!formData.Name.trim()) {
            errors.Name = "Name is required";
        }
        
        if (!formData["Email Address"].trim()) {
            errors["Email Address"] = "Email is required";
        } else if (!validateEmail(formData["Email Address"])) {
            errors["Email Address"] = "Please enter a valid email address";
        }
        
        if (!formData["Client Type"].trim()) {
            errors["Client Type"] = "Please select your client type";
        }
        
        if (formData["Interested in:"].length === 0) {
            errors["Interested in:"] = "Please select at least one interest";
        }
        
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    async function submitForm(event) {
        event.preventDefault();

        // Validate form before submission
        if (!validateForm()) {
            return;
        }

        setIsSubmitting(true);

        const object = {
            ...formData,
            access_key: constants.EMAIL_ACCESS_KEY,
            subject: "New Lead Interested in Real Estate Reports",
        };

        try {
            const res = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify(object)
            });

            if (!res.ok) {
                throw new Error("Failed to send email");
            }

            const responseData = await res.json();

            if (responseData?.success) {
                console.log("Success", responseData);
                setPopup({ 
                    subject: 'Thanks for your message!', 
                    message: 'We will get back to you as soon as possible' 
                });
                // Clear form after successful submission
                setFormData({
                    Name: "",
                    "Email Address": "",
                    "Client Type": "",
                    "Interested in:": [],
                });
                setFormErrors({});
            } else {
                setPopup({ 
                    subject: 'We encountered an error in sending this message', 
                    message: 'Please try again later' 
                });
            }
        } catch (err) {
            console.log(err);
            setPopup({ 
                subject: 'We encountered an error in sending this message', 
                message: 'Please try again later' 
            });
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <>
        <div className="max-w-[1100px] mx-auto grid md:grid-cols-2 px-6 gap-x-24 gap-y-10 min-h-[70vh] my-12">
            <div>
                <h1 className="text-4xl text-black font-mont ">FREE REAL ESTATE REPORTS</h1>

                <p className='font-semibold text-med-grey my-5'>Get exclusive buyer & seller real estate reports to help you with your next purchase or sale. Get insider tips and tricks, and learn how to invest your time and money wisely in the real estate market. Just complete the form below, select all the reports you'd like to receive and have them emailed to your inbox right away. Get started now!</p>
                <form id="form" onSubmit={submitForm}>
                    <div className="form-item">
                        <label className="form-label">Name*</label>
                        <input 
                            className={`form-input ${formErrors.Name ? 'border-red-500' : ''}`}
                            name="Name" 
                            placeholder="Full Name"
                            value={formData.Name}
                            onChange={handleInputChange}
                        />
                        {formErrors.Name && (
                            <p className="text-red-500 text-sm mt-1">{formErrors.Name}</p>
                        )}
                    </div>
                    <div className="form-item">
                        <label className="form-label">Email*</label>
                        <input 
                            className={`form-input ${formErrors["Email Address"] ? 'border-red-500' : ''}`}
                            name="Email Address" 
                            type="email"
                            placeholder="Email Address"
                            value={formData["Email Address"]}
                            onChange={handleInputChange}
                        />
                        {formErrors["Email Address"] && (
                            <p className="text-red-500 text-sm mt-1">{formErrors["Email Address"]}</p>
                        )}
                    </div>
                    <div className="form-item">
                        <label className="form-label">I am a*</label>
                        <select 
                            className={`form-input ${formErrors["Client Type"] ? 'border-red-500' : ''}`}
                            name="Client Type"
                            value={formData["Client Type"]}
                            onChange={handleInputChange}
                        >
                            <option value="">Please Select</option>
                            <option value="Buyer">Buyer</option>
                            <option value="Seller">Seller</option>
                            <option value="Renter">Renter</option>
                            <option value="Other">Other</option>
                        </select>
                        {formErrors["Client Type"] && (
                            <p className="text-red-500 text-sm mt-1">{formErrors["Client Type"]}</p>
                        )}
                    </div>
                    <div className='form-item'>
                        <label className="form-label">I am interested in:*</label>
                        <div className={`grid grid-cols-2 gap-3 mt-3 ${formErrors["Interested in:"] ? 'border border-red-500 rounded p-3' : ''}`}>
                            <div className='cursor-pointer'>
                                <input 
                                    className='mr-2' 
                                    name="Interested in:" 
                                    value='Buying guides' 
                                    type="checkbox" 
                                    id="1"
                                    checked={formData["Interested in:"].includes('Buying guides')}
                                    onChange={handleCheckboxChange}
                                />
                                <label htmlFor="1">Guides for Buying</label>
                            </div>
                            <div>
                                <input 
                                    className='mr-2' 
                                    name="Interested in:" 
                                    value='Selling guides' 
                                    type="checkbox" 
                                    id="2"
                                    checked={formData["Interested in:"].includes('Selling guides')}
                                    onChange={handleCheckboxChange}
                                />
                                <label htmlFor="2">Guides for Selling</label>
                            </div>
                            <div>
                                <input 
                                    className='mr-2' 
                                    name="Interested in:" 
                                    value='Choosing realtor' 
                                    type="checkbox" 
                                    id="3"
                                    checked={formData["Interested in:"].includes('Choosing realtor')}
                                    onChange={handleCheckboxChange}
                                />
                                <label htmlFor="3">Choosing a Realtor</label>
                            </div>
                            <div>
                                <input 
                                    className='mr-2' 
                                    name="Interested in:" 
                                    value='Renovations' 
                                    type="checkbox" 
                                    id="4"
                                    checked={formData["Interested in:"].includes('Renovations')}
                                    onChange={handleCheckboxChange}
                                />
                                <label htmlFor="4">Home Renovations</label>
                            </div>
                        </div>
                        {formErrors["Interested in:"] && (
                            <p className="text-red-500 text-sm mt-1">{formErrors["Interested in:"]}</p>
                        )}
                    </div>
                    <button 
                        type='submit' 
                        disabled={isSubmitting}
                        className={`btn-primary self-start rounded-none px-10 mt-3 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
                    >
                        {isSubmitting ? 'Submitting...' : 'Submit'}
                    </button>
                </form>
            </div>
            <div className="overflow-hidden h-[600px] ">
                <img className="h-full w-full object-cover" src={img} alt="Business woman working" />
            </div>
        </div>
        {popup &&
                <>
                    <div className="backdrop" />
                    <div className="popup">
                        <h5 className="font-bold text-black text-lg">{popup.subject}</h5>
                        <p className="font-semibold text-med-grey tracking-wide mb-3">{popup.message}</p>
                        <button onClick={() => setPopup(false)} className="btn-primary">Close</button>
                    </div>
                </>}
        </>
    )
}